import { NgModule } from '@angular/core';

import { SkyResourcesPipe } from './resources.pipe';
import { SkyResourcesService } from './resources.service';


export class SkyResourcesModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [SkyResourcesPipe],
  providers: [SkyResourcesService],
  exports: [SkyResourcesPipe]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
